import * as yup from "yup";

// 폼 데이터 타입 정의
export interface CheckPromotionFormData {
  promotionCode: string;
  referralId?: string;
  issueAppList?: string[];
  packageName?: string;
  products?: string[];
}

// yup 스키마 정의
export const checkPromotionSchema = yup.object().shape({
  promotionCode: yup
    .string()
    .required("siteType.premium.detail.plan.invalidPromotionCode")
    .max(44, "common.alert.overPromotionCode")
    .trim(),
  referralId: yup.string().optional(),
  issueAppList: yup.array().of(yup.string().required()).optional(),
  packageName: yup.string().optional(),
  products: yup.array().of(yup.string().required()).optional(),
});
